import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'engineerName',
    fieldName: '工程师名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'assignTime',
    fieldName: '分配时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairStartTime',
    fieldName: '开始时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'expectedCompletedTime',
    fieldName: '预计完成'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'actualCompletedTime',
    fieldName: '完成时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'expectedCompletedDays',
    fieldName: '预计天数'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'overtime',
    fieldName: '是否超时',
    convert: context => {
      const { rowData } = context
      if (undefined === rowData.overtime || rowData.overtime == null) {
        return ''
      }
      return rowData.overtime ? '是' : '否'
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '维修状态'
  }
]
